import {LOGIN} from '../actions/const';

const initialState = {
  isLoggingIn: false
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case LOGIN:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/Login.js